export * as comment from './CommentBox'
export * as projectCard from './ProjectCard'
export * as rewardCard from './RewardCard/RewardCard'
export * as userBackofficeListingItem from './UserBackofficeListingItem'

export { AboutOwner } from './AboutOwner'
export { CardTypeSelector } from './CardTypeSelector'
export { DiscordRoleList, discordRoleListString, formatDiscordRoles } from './DiscordRoleList'
export { DropoffPicker, type DropoffPickerProps } from './DropoffPicker'
export { GoalCard } from './GoalCard'
export { HorizontalMedia } from './HorizontalMedia'
export { LocationPicker, type LocationPickerProps, type Location } from './LocationPicker/LocationPicker'
export { MediaStackWithPath } from './MediaStackWithPath'
export { MembershipDefaultBanner } from './MembershipDefaultBanner'
export { MembershipOrderItem } from './MembershipCardOrderItem'
export { MembershipProjectCard as MembershipCard } from './MembershipProjectCard'
export { NewsCard, type NewsCardProps } from './NewsCard'
export { NewsContent, type NewsContentProps } from './NewsContent'
export { PopHeading } from './PopHeading'
export { ProjectWidgetPreview } from './ProjectWidgetPreview'

// HACK(Hopefully temporary): When exporting Wysiwyg builds, we're also exposing CKEditor which comes
//  bundled with various assets (CSS and SVG files, for instance).
//  During build steps, these types of files need either to be loaded or ignored (which is our target)
//  Alas, and even though we have ignore rules for the assets, our Next.js app build still
//  struggles and Webpack somehow keeps asset imports it should ignore which leads to straight crashes.
let StandardWysiwyg = (props: any) => {}
let TinyWysiwyg = (props: any) => {}

if (process.env.NEXT_BUILD === 'true') {
  StandardWysiwyg = () => {}
  TinyWysiwyg = () => {}
} else {
  import('./StandardWysiwyg').then((module) => {
    StandardWysiwyg = module.StandardWysiwyg
  })
  import('./TinyWysiwyg').then((module) => {
    TinyWysiwyg = module.TinyWysiwyg
  })
}

export { StandardWysiwyg, TinyWysiwyg }
